/** @module app.test */

import { autoinject, PLATFORM } from 'aurelia-framework';
import { AppLogger } from 'app/shared/lib/logging/app-logger';
import { AppModule } from 'app/shared/config/modules';
import { IAppRouteConfig } from 'app/shared/config/router-types';

@autoinject
export class TestModule extends AppModule {

    public readonly code = 'cm';

    constructor(private readonly logger: AppLogger) {
        super();

        logger.source = this;
    }

    public getRoutes(): IAppRouteConfig[] {
        return [
            { route: 'test/date-tests', name: 'test.date-tests', moduleId: PLATFORM.moduleName('app/test/pages/date-tests/date-tests-page'), title: 'Date/Time Tests', settings: { bypassAuthentication: true } },
            { route: 'test/form-tests', name: 'test.form-tests', moduleId: PLATFORM.moduleName('app/test/pages/form-tests/form-tests-page'), title: 'Form Tests', setings: { bypassAuthentication: true } },
            { route: 'test/unit-tests', name: 'test.unit-tests', moduleId: PLATFORM.moduleName('app/test/pages/unit-tests/unit-tests-page'), title: 'Unit Tests', settings: { bypassAuthentication: true } }
        ];
    }

}
